import React from 'react';
import useToAsset from '../../hooks/use-to-asset.js';
import useToWalletAccount from '../../hooks/use-to-wallet-account.js';
import useToSideLoading from '../../hooks/use-to-side-loading.js';
const ToWalletAccount = ({ Component, className, style, onPress, }) => {
    const [toAsset] = useToAsset();
    const loading = useToSideLoading();
    const [toWalletAccount, setToWalletAccount] = useToWalletAccount();
    const handlePress = async () => {
        const result = await onPress({
            side: 'to',
            assetName: toAsset.name,
            currentWalletAccount: toWalletAccount,
        });
        if (result)
            setToWalletAccount(result);
    };
    if (Component) {
        return (React.createElement(Component, { walletAccount: toWalletAccount, className: className, style: style, onPress: handlePress, loading: loading }));
    }
    return null;
};
export default ToWalletAccount;
